<template>
  <div>
    <el-dialog :show-close=false :visible.sync="centerDialogVisible" top="25vh"  width="445px"  center :close-on-click-modal=false :close-on-press-escape=false >
      <div class="txt">当前平台暂未开放注册，将自动跳转至金太阳老师，请重新扫码登录，登录后可下载资源。</div>
      <span class="dialog-footer">即将跳转<strong>{{count}}</strong></span>
    </el-dialog>
  </div>
</template>
<script>
import { setInterval, clearInterval } from 'timers'
export default {
  name: 'CompleteInfoDialog',
  data () {
    return {
      centerDialogVisible: false,
      count: 5
    }
  },
  methods: {
    showDialog () {
      let _this = this
      this.centerDialogVisible = true
      let timer = setInterval(function () {
        _this.count = _this.count - 1
        if (_this.count <= 0) {
          clearInterval(timer)
          window.location.href = 'https://teacher.kingsunedu.com'
        }
      }, 1000)
    },
    toInfoDetail () {
      this.centerDialogVisible = false
    }
  }
}
</script>
<style scoped>
.txt{
  text-align: left;
  padding: 0 5px 20px 20px;
  font-size: 16px;
  color: #333;
  line-height: 1.8;
}
.sure-bind{
  width: 200px;
}
.dialog-footer {
  display: block;
  text-align: center;
  padding: 10px 0;
}
strong {
  color: #ff0000;
  font-size: 16px;
  margin-left: 10px;
}
</style>
